import React from 'react';
import {useTranslation} from "react-i18next";

import css from './ButtonUpdate.module.css';
import { Loader } from 'lucide-react';


const ButtonUpdate = (props) => {
    const {onClick, isLoading} = props;
    const {t} = useTranslation();


    return (
        <button className={css.wrap} onClick={onClick} disabled={isLoading}>
            {t('update-text')}
            {isLoading && <Loader className={css.loader} />}
        </button>
    );
};

export {ButtonUpdate};